import React from "react"
import { useFormContext } from "react-hook-form"
import DayScheduleSelector from "src/main/Settings/PublicProfile/Fuel/DayScheduleSelector"
import SeasonDateSelector from "src/main/Settings/PublicProfile/Fuel/SeasonDateSelector"

import Button from "src/components/Button"
import Form from "src/components/Form"
import HeadingSectionHeader from "src/components/Heading/HeadingSectionHeader"
import HeadingSubSectionHeader from "src/components/Heading/HeadingSubSectionHeader"

export const getDaysInMonth = (monthValue) => {
  if (!monthValue) return []

  const currentYear = new Date().getFullYear()
  const daysInMonth = new Date(currentYear, parseInt(monthValue), 0).getDate()

  return Array.from({ length: daysInMonth }, (_, i) => i + 1)
}

const FuelDockAvailability = () => {
  const {
    control,
    watch,
    setValue,
    register,
    formState: { errors },
    clearErrors,
  } = useFormContext()

  const startMonth = watch("fuelDockAvailability.season.startMonth")
  const endMonth = watch("fuelDockAvailability.season.endMonth")
  const startDay = watch("fuelDockAvailability.season.startDay")
  const endDay = watch("fuelDockAvailability.season.endDay")
  const yearRound = watch("fuelDockAvailability.season.yearRound")

  const daysOfWeek = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ]

  const startMonthDays = getDaysInMonth(startMonth)
  const endMonthDays = getDaysInMonth(endMonth)

  const seasonDatesSelected =
    yearRound || (startMonth && endMonth && startDay && endDay)
  const anyDaysEnabled = daysOfWeek.some((day) => {
    const dayKey = `fuelDockAvailability.days.${day.toLowerCase()}`
    return watch(`${dayKey}.enabled`)
  })

  const handleDisableAllDays = () => {
    daysOfWeek.forEach((day) => {
      const dayKey = `fuelDockAvailability.days.${day.toLowerCase()}`
      setValue(`${dayKey}.enabled`, false)
    })
  }

  return (
    <div className="mb-6">
      <div className="flex flex-col space-y-2">
        <HeadingSectionHeader>Fuel Dock Hours</HeadingSectionHeader>
        <Form.Checkbox
          {...register("fuelDockAvailability.enabled")}
          compact
          label="Show on public profile"
        />
      </div>
      <div className="px-2">
        <div className="mb-2 mt-4 flex flex-col space-y-2">
          <HeadingSubSectionHeader>Season</HeadingSubSectionHeader>
          <div className="px-2">
            <Form.Checkbox
              {...register("fuelDockAvailability.season.yearRound")}
              onChange={(event) => {
                setValue(
                  "fuelDockAvailability.season.yearRound",
                  event.target.checked
                )
                if (event.target.checked) {
                  setValue("fuelDockAvailability.season.startMonth", "")
                  setValue("fuelDockAvailability.season.startDay", "")
                  setValue("fuelDockAvailability.season.endMonth", "")
                  setValue("fuelDockAvailability.season.endDay", "")
                  clearErrors("fuelDockAvailability.season")
                }
              }}
              compact
              label="Open year round"
            />
          </div>
        </div>
        <div className="mb-4 grid grid-cols-12 gap-4 px-2">
          <SeasonDateSelector
            prefix="Start"
            monthValue={startMonth}
            monthDays={startMonthDays}
            disabled={yearRound}
          />
          <SeasonDateSelector
            prefix="End"
            monthValue={endMonth}
            monthDays={endMonthDays}
            disabled={yearRound}
          />
        </div>
        <div className="mb-2 mt-4 flex h-6 items-center space-x-2">
          <HeadingSubSectionHeader>Daily Hours</HeadingSubSectionHeader>
          {anyDaysEnabled && seasonDatesSelected && (
            <Button
              small
              disabled={!seasonDatesSelected}
              onClick={handleDisableAllDays}
            >
              Clear All
            </Button>
          )}
        </div>
        {errors?.fuelDockAvailability?.root && (
          <Form.Error>{errors.fuelDockAvailability.root.message}</Form.Error>
        )}
        <div className="mb-4 flex flex-col space-y-4 px-2 md:flex-row md:space-x-4 md:space-y-0">
          <div className="flex w-full flex-col space-y-4">
            {daysOfWeek.map((day) => (
              <DayScheduleSelector
                key={day}
                day={day}
                control={control}
                watch={watch}
                disabled={!seasonDatesSelected}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default FuelDockAvailability
